import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { Filter } from './accumulator-filter';
import MemberSkeleton from '../memberSkeleton';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';
import { axiosInstance } from 'src/api/axios';

import APIEndpoints from 'src/Admin/api/APIEndpoints';
import CoveredServicesCost from './Covered-Service-Cost/CoveredServicesCost';
import './accumulator.scss';
import { setNetworkList } from 'src/redux/admin/accumulatorSlice';
import {
  getNetworkByMasterId,
  identifyDefaultNetwork,
} from '../../../../Member/utils/Coverage';

const CoverageValueComponent = ({ label, value }) => {
  return (
    <div className="justify-content-between d-flex ">
      {/*<div className="col">*/}
      <span className="label col-md-6 m-0 p-0">{label}</span>
      <span className="value col-md-6 m-0 p-0">{value}</span>
      {/*</div>*/}
    </div>
  );
};
const validCoverageTypeOptions = [
  'Medical',
  'Vision',
  'Dental',
  'Prescription',
];

const Accumulators = (props) => {
  const dispatch = useDispatch();
  const { userOID, memberType, selectedUser, isFamilySelected } = props;
  const [isDataFetching, setIsDataFetching] = useState(true);
  const [dataFetchFailed, setDataFetchFailed] = useState(false);
  const [noAccumulatorFound, setNoAccumulatorFound] = useState(false);
  const [coverageFetchFailed, setCoverageFetchFailed] = useState(false);
  const [eligibilityCoverage, setEligibilityCoverage] = useState(null);
  const [coverageTypeOptions, setCoverageTypeOptions] = useState([]);
  const [selectedCoverage, setSelectedCoverage] = useState(null);
  const [effectiveDateRaw, setEffectiveDateRaw] = useState(new Date());
  const [productCoverageMap, setProductCoverageMap] = useState({});
  //const [firstItemSelected, setFirstItemSelected] = useState(null);
  const [memberExtCoveragedata, setMemberExtCoveragedata] = useState(null);
  const [effectiveDate, setEffectiveDate] = useState(
    moment().format('YYYY-MM-DD'),
  );
  const [planNetworksList, setPlanNetworksList] = useState([]);
  const [networkOptions, setNetworkOptions] = useState([]);
  const [selectedNetwork, setSelectedNetwork] = useState(null);
  const [serviceCodeNames, setServiceCodeNames] = useState([]);
  const [selectedServiceCodeName, setSelectedServiceCodeName] = useState(null);
  const [defaultServiceCodeName, setDefaultServiceCodeName] = useState({
    label: 'HEALTH BENEFIT PLAN COVERAGE - 30',
    value: '30',
  });
  const [activeCoverageSummary, setActiveCoverageSummary] = useState(null);

  useEffect(() => {
    if (Object.keys(productCoverageMap).length > 0 && selectedCoverage?.value) {
      setActiveCoverageSummary(productCoverageMap[selectedCoverage?.value]);
    }
  }, [selectedCoverage, eligibilityCoverage, productCoverageMap]);

  const { networkListWithMasterId } = useSelector(
    ({ accumulator }) => accumulator,
  );
  const { Network_Setting } = useSelector((state) => state.app.appConfigs);

  //const { Value_Network_For_Coverage_Admin } = Network_Setting;
  const { Value_Network_For_Accumulators_Admin } = Network_Setting;

  const { Coverage_Network } = useSelector((state) => state.app.customNetwork);
  const coverageChangeHandler = (selectedValue) => {
    setSelectedCoverage(selectedValue);
  };

  const networkChangeHandler = (value) => {
    setSelectedNetwork(value);
  };

  const fetchCovData = async (effectiveDate) => {
    setCoverageFetchFailed(false);
    try {
      const res = await axiosInstance.get(
        `${APIEndpoints.getMemberCoveragePlan()}${memberType}/oid/${userOID}/planstartdate/${effectiveDate}/planenddate/${effectiveDate}`,
      );
      setIsDataFetching(false);
      console.log('***** >>>>>', res.data.Response);
      const memberEligibilityCoverage = res.data.Response.EligibilityCoverage;
      setEligibilityCoverage(memberEligibilityCoverage[0]);
      console.log(
        'memberEligibilityCoverage[0].MemberCoverage',
        memberEligibilityCoverage[0].MemberCoverage,
      );
      setMemberExtCoveragedata(memberEligibilityCoverage[0].MemberCoverage);
      const coverageOptions = [];
      const coverageMap = {};
      const coverages = [...memberEligibilityCoverage[0].MemberCoverage].map(
        (v, i) => {
          if (validCoverageTypeOptions.includes(v.Product)) {
            coverageMap[v.Product] = v;
            coverageOptions.push({ label: v.Product, value: v.Product });
          }
          if (i === memberEligibilityCoverage[0].MemberCoverage?.length - 1) {
            setCoverageTypeOptions(coverageOptions);
            setProductCoverageMap(coverageMap);
          }
          return { label: v.Product, value: v.Product };
        },
      );
      //.filter((v) => validCoverageTypeOptions.includes(v.value));
      console.log('active coverages are >>>>>', coverages);
      //setCoverageTypeOptions(coverages);
      //getPlanNetworksList();
      if (coverages.length > 0) {
        setSelectedCoverage(coverages[0]);
      }
    } catch (error) {
      setCoverageFetchFailed(true);
    }
  };

  async function getPlanNetworksList() {
    let networkCall = [];
    //Network code start here
    if (networkListWithMasterId && networkListWithMasterId.length > 0) {
      networkCall = memberExtCoveragedata.filter(
        (o1) =>
          !networkListWithMasterId.some((o2) => o1?.MasterId === o2.masterId),
      );
    } else {
      networkCall = memberExtCoveragedata;
    }
    let networkByMasterList = [];
    let networkByMasterListClubed = [];
    if (networkCall && networkCall.length > 0) {
      networkCall = networkCall.filter((f) => f?.MasterId > 0);
      const promises = networkCall.map(async (item) => {
        let networkItem;
        if (
          item?.MasterId > 0 &&
          (item?.Product === 'Medical' ||
            item?.Product === 'Dental' ||
            item?.Product === 'Prescription' ||
            item?.Product === 'Vision')
        ) {
          networkItem = await axiosInstance.get(
            `${APIEndpoints.getMemberCoveragePlanNetworks()}MasterID/${
              item?.MasterId
            }/product/${item?.Product}/benefitplan/${btoa(item?.BenefitPlan)}`,
          );
        }
        return networkItem;
      });
      try {
        const results = await Promise.all(
          promises.map((p) => p.catch((e) => e)),
        );
        const validResults = results.filter(
          (result) => !(result instanceof Error),
        );
        networkByMasterList = getNetworkByMasterId(validResults);
        const networkListFiltered = networkByMasterList.filter(
          (o1) =>
            !networkListWithMasterId.some((o2) => o1.MasterId === o2.MasterId),
        );
        if (networkListFiltered.length > 0) {
          networkByMasterListClubed = networkListFiltered.concat(
            networkListWithMasterId?.length > 0 ? networkListWithMasterId : [],
          );
          console.log(networkByMasterListClubed, 'networkByMasterListClubed');
          dispatch(setNetworkList(networkByMasterListClubed));
        }
      } catch (error) {
        console.log('Network API fails');
      }
    }
    let firstItemSelected = [];
    if (selectedCoverage?.value) {
      const selectedCoveragefor =
        memberExtCoveragedata &&
        memberExtCoveragedata.filter(
          (data) => data.Product === selectedCoverage?.value,
        );
      firstItemSelected = selectedCoveragefor[0];
      console.log(selectedCoveragefor[0], 'selectedCoverage');
    }

    const lastestNetworkList =
      networkByMasterListClubed && networkByMasterListClubed.length > 0
        ? networkByMasterListClubed
        : networkListWithMasterId;

    let defaultNetwork = {
      selected: { label: 'Default', value: 0 },
    };
    console.log(firstItemSelected, 'firstItemSelected');
    if (Value_Network_For_Accumulators_Admin === 'tier') {
      defaultNetwork = identifyDefaultNetwork(
        firstItemSelected,
        lastestNetworkList,
        Coverage_Network,
        true,
      );
    } else {
      defaultNetwork = identifyDefaultNetwork(
        firstItemSelected,
        lastestNetworkList,
        Coverage_Network,
      );
    }
    console.log('accumulatore network options are >>>>>', defaultNetwork);
    setSelectedNetwork(defaultNetwork.selected);
    setNetworkOptions(defaultNetwork.networkProps);
  }

  //get code set names
  const getCodeSetNamesApi = async () => {
    const res = await axiosInstance.get(APIEndpoints.getCodeSetNames());
    console.log('code set names list is >>>> ', res.data.Response.EnabledCode);
    if (res.data.Response.EnabledCode?.length) {
      setServiceCodeNames(
        [...res.data.Response.EnabledCode].map((v) => {
          if (v.Code == 30) {
            console.log('DEFAULT >>>>>', {
              label: `${v.Description} - ${v.Code}`,
              value: v.Code,
            });
            setSelectedServiceCodeName({
              label: `${v.Description} - ${v.Code}`,
              value: v.Code,
            });
            setDefaultServiceCodeName({
              label: `${v.Description} - ${v.Code}`,
              value: v.Code,
            });
          }
          return { label: `${v.Description} - ${v.Code}`, value: v.Code };
        }),
      );
    }
    //setServiceCodeNames
  };

  const serviceCodeNameChangeHandler = (value) => {
    setSelectedServiceCodeName(value);
  };

  useEffect(() => {
    setIsDataFetching(true);

    getCodeSetNamesApi();
    setTimeout(() => {
      //setIsDataFetching(false);
    }, 3000);
  }, []);

  useEffect(() => {
    (() => {
      fetchCovData(effectiveDate);
    })();
  }, [effectiveDate, userOID]);

  useEffect(() => {
    if (selectedCoverage?.value) {
      getPlanNetworksList();
    }
  }, [selectedCoverage, userOID]);

  const onChangeEffectiveDate = (date) => {
    console.log('new selected date is ', moment(date).format('YYYY-MM-DD'));
    setEffectiveDateRaw(date);
    setEffectiveDate(moment(date).format('YYYY-MM-DD'));
  };

  return (
    <>
      {isDataFetching ? (
        <MemberSkeleton />
      ) : dataFetchFailed ? (
        <Container className="px-0">
          {noAccumulatorFound ? (
            <CustomClientError
              ErrorHeading="No Accumulators found!"
              ErrorMessage="No coverage history data found for current member "
              NoDataFound={true}
            />
          ) : (
            <CustomClientError
              ErrorHeading="Something went wrong with request!"
              ErrorMessage="Server request failed. Please contact support team."
            />
          )}
        </Container>
      ) : (
        <>
          <div className="coverage-info accumulator-details-main">
            {/*filter bar */}
            <div className="coverage-filter-container filter-bar-border-top filter-bar-border-bottom mt-2 mb-md-4 mb-xs-3">
              <div className="container-offset">
                <Filter
                  coverageChangeHandler={coverageChangeHandler}
                  coverageTypeOptions={coverageTypeOptions}
                  selectedCoverage={selectedCoverage}
                  onChangeEffectiveDate={onChangeEffectiveDate}
                  effectiveDate={effectiveDateRaw}
                  networkOptions={networkOptions}
                  selectedNetwork={selectedNetwork}
                  onChangeNetwork={networkChangeHandler}
                  serviceCodeNames={serviceCodeNames}
                  onServiceCodeNameChange={serviceCodeNameChangeHandler}
                  selectedServiceCodeName={
                    selectedServiceCodeName || defaultServiceCodeName
                  }
                />
              </div>
            </div>

            {/*coverage summary */}
            {activeCoverageSummary && (
              <div className="container-offset">
                <div className="coverage-summary-card bg-white card">
                  <h4 className="card-title">Coverage Summary</h4>
                  <div className="coverage-values-container row m-0 p-0">
                    <Col md={8}>
                      <Row>
                        {activeCoverageSummary['BenefitPlan'] && (
                          <Col md={6} className="value-row">
                            <CoverageValueComponent
                              value={activeCoverageSummary['BenefitPlan']}
                              label="Plan Name"
                            />
                          </Col>
                        )}
                        {/*<Col md={6} className="value-row">
                          <CoverageValueComponent
                            value={activeCoverageSummary['PlanEffectiveDate']}
                            label="Last Coverage Change"
                          />
                        </Col>*/}
                        {eligibilityCoverage['Status'] && (
                          <Col md={6} className="value-row">
                            <CoverageValueComponent
                              value={eligibilityCoverage['Status']}
                              label="Coverage Status"
                            />
                          </Col>
                        )}
                        {activeCoverageSummary['CoverageLevel'] && (
                          <Col md={6} className="value-row">
                            <CoverageValueComponent
                              value={activeCoverageSummary['CoverageLevel']}
                              label="Coverage Level"
                            />
                          </Col>
                        )}
                        {/*<Col md={6} className="value-row">
                          <CoverageValueComponent
                            value="01 Jan 2022"
                            label="Coverage Active From"
                          />
                        </Col>*/}
                      </Row>
                    </Col>
                  </div>
                </div>
              </div>
            )}

            {/*Accumulator summary */}
            <div className="container-offset">
              <Row className="covered-services mt-4">
                <Col>
                  <CoveredServicesCost
                    activeCoverageType={selectedCoverage?.value}
                    masterId={
                      selectedCoverage?.value
                        ? productCoverageMap[selectedCoverage?.value]
                            ?.MasterId || null
                        : null
                    }
                    benefitPlan={
                      selectedCoverage?.value
                        ? productCoverageMap[selectedCoverage?.value]
                            ?.BenefitPlan || null
                        : null
                    }
                    selectedUser={selectedUser}
                    currentUserOid={userOID}
                    memberType={memberType}
                    memberExtCoveragedata={memberExtCoveragedata}
                    selectedNetwork={selectedNetwork}
                    selectedCoverage={selectedCoverage}
                    effectiveDate={effectiveDate}
                    selectedServiceCodeName={
                      selectedServiceCodeName || defaultServiceCodeName
                    }
                    isFamilySelected={isFamilySelected}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Accumulators;
